// extracted by mini-css-extract-plugin
export var logo = "_i5-2";
export var logoWrapper = "_i5-1";
export var strip = "_i5-0";